/**
 * Created by tomers on 12/18/2014.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require("backbone");
    var TagItemModel = require("ui/tags-container/js/models/TagItemModel");

    var TagItemsCollection = Backbone.Collection.extend({
        model: TagItemModel,

        getComparator: function() {
            return this.comparator;
        },
        setComparator: function(comparator) {
            this.comparator = comparator;
        }
    });

    TagItemsCollection.Model = TagItemModel;

    return TagItemsCollection;

});
